import { checkForExpiredJwtResponse } from "../Common/commonFunctions";
import { JWT_EXPIRED } from "../store/actions";
import { axiosInstance } from "./axiosInstance";

const AxiosResponseInterceptor = (store) => {

    axiosInstance.interceptors.response.use(resp => {
        if(checkForExpiredJwtResponse(resp?.data?.statusCode)) {
            store.dispatch({ type: JWT_EXPIRED, payload: true });
        }
        return resp;
    });
}

export default AxiosResponseInterceptor;